import React, {Component} from 'react';
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";
import {CardTitle, P2} from "../Kit/Kit";
import TeamCard from "./TeamCard";
import bg from '../../assets/img/teamBG.jpg';
import {AnchorPoint} from "./OurStory";

const StyledBodyContainer = BodyContainer.extend`
  @media(min-width: 768px){
  background: url(${bg}) no-repeat;
  background-size: cover;
 }
  
  @media(min-width: 768px){
    padding: 40px 100px 0;
  }
  
  @media(min-width: 992px) {
    padding: 50px 120px 0;
  }
  
  @media(min-width: 1200px) {
    padding: 50px 180px 0;
  }
`;

const TeamGrid = styled.div`
  margin-top: 24px;
  display: grid;
  grid-gap: 36px;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  
  .empty {
    display: none;
  }
  
  @media(min-width: 768px){
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-gap: 36px;
    
    .empty{
      display: block;
    }
  }
  
  
`;

const PresidentCard = styled(TeamCard)``;

class Team extends Component {
    render() {
        const {onClick, team} = this.props;
        const president = team[0];
        const teamData = team.slice(1);
        return (
          <StyledBodyContainer>
              <AnchorPoint id={'team'}/>
              <CardTitle>GET TO KNOW OUR TEAM</CardTitle>
              <P2>Click images for more information</P2>
              <TeamGrid>
                  <div className="empty"/>
                  <PresidentCard
                    img={president.image.source_url}
                    alt={president.image.alt_text}
                    name={president.name}
                    position={president.position}
                    onClick={() => onClick(president.id)}
                  />
                  <div className="empty"/>
                  {teamData.map(i => {
                      return (
                        <TeamCard
                          key={i.name}
                          img={i.image.source_url}
                          alt={i.image.alt_text}
                          name={i.name}
                          position={i.position}
                          onClick={() => onClick(i.id)}
                        />
                      )
                  })}
              </TeamGrid>
          </StyledBodyContainer>
        );
    }
}

export default Team;


// WEBPACK FOOTER //
// ./src/components/GetToKnow/Team.js